import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backtoPrevPage: {
    display: "flex",
    flexDirection: "row",
    width: "fit-content",
    color: theme.palette.primary.main,
    opacity: 0.8,
    "&:hover": {
      opacity: 1,
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
